module.exports = __webpack_public_path__ + "img/02.e7d326d4.jpg";